import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class RoadmapStrategyCreateController extends Controller {
  @service store;

  queryParams = [
    'grouping',
    'status',
    'themes',
    'sources',
    'product_managers',
    'teams',
    'columns',
  ];

  @tracked grouping = '';
  @tracked status = [
    'ACTIVE',
    'READY',
    'READY FOR PLANNING',
    'DISCOVERY',
    'DRAFT',
  ];
  @tracked themes = [];
  @tracked sources = [];
  @tracked product_managers = [];
  @tracked teams = [];
  @tracked initiatives = [];

  get params() {
    return {
      status: this.status,
      themes: this.themes,
      sources: this.sources,
      product_managers: this.product_managers,
      teams: this.teams,
    };
  }
  @action
  setStatus(e) {
    this.status = e;
  }

  @action
  setThemes(e) {
    this.themes = e;
  }

  @action
  setSources(e) {
    this.sources = e;
  }

  @action
  setPms(e) {
    this.product_managers = e;
  }

  @action
  setTeams(e) {
    this.teams = e;
  }

  @action
  setGrouping(e) {
    this.grouping = e.value;
  }

  @action
  fetchInitiatives() {
    this.store.query('initiative', this.params).then((res) => {
      this.initiatives = res.slice();
    });
  }
}
